"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.respond = exports.request = exports.Action = exports.ActionType = void 0;
var helper_1 = require("../helper");
var types_1 = require("../types");
var ActionType;
(function (ActionType) {
    ActionType["REQUEST"] = "APP::SESSION_TOKEN::REQUEST";
    ActionType["RESPOND"] = "APP::SESSION_TOKEN::RESPOND";
})(ActionType = exports.ActionType || (exports.ActionType = {}));
var Action;
(function (Action) {
    Action["REQUEST"] = "REQUEST";
    Action["RESPOND"] = "RESPOND";
})(Action = exports.Action || (exports.Action = {}));
function request() {
    return helper_1.actionWrapper({
        group: types_1.Group.SessionToken,
        type: ActionType.REQUEST,
    });
}
exports.request = request;
function respond(sessionToken) {
    return helper_1.actionWrapper({
        payload: sessionToken,
        group: types_1.Group.SessionToken,
        type: ActionType.RESPOND,
    });
}
exports.respond = respond;
